export const PLAN_ORDER = ["free", "starter", "basic", "pro", "enterprise"] as const;

export type PlanId = (typeof PLAN_ORDER)[number];
